class AppCache {

    addDataIntoCache(cacheName, url, response) {
        const data = new Response(JSON.stringify(response));
        if ('caches' in window) {
            caches.open(cacheName).then((cache) => {
                cache.put(url, data);
            });
        }
    }

    getAllCacheData = async (url, requestedKey) => {
        let names = await caches.keys();
        if (names.includes(requestedKey) === true) {
            const cacheStorage = await caches.open(requestedKey);
            const cachedResponse = await cacheStorage.match(url);
            if(cachedResponse === undefined){
                return [];
            }
            let data = await cachedResponse.json();
            return data;
        }
        return [];
    }

    deleteAllCacheData = async () => {
        let names = await caches.keys();
        names.map((eachKey) => {
            caches.delete(eachKey);
        });
    }
}

const applicatonCache = new AppCache();

export { applicatonCache };